import { Cpu, Sigma } from "lucide-react";
import type { CalculationResult } from "../calculators/weldParameter/types";
import { copy } from "../data/i18n";
import { compactDecimalsFor, decimalsFor, toDisplayValue, unitFor } from "../data/units";
import type { Language, UnitSystem } from "../types/preferences";
import { formatNumber } from "../utils/numberFormat";

type ResultPanelProps = {
  result: CalculationResult;
  language: Language;
  unitSystem: UnitSystem;
};

export function ResultPanel({ result, language, unitSystem }: ResultPanelProps) {
  const t = copy[language];
  const locale = language === "de" ? "de-DE" : "en-US";
  const resultValue = toDisplayValue(result.metric, result.value, unitSystem);
  const resultDecimals = decimalsFor(result.metric, unitSystem);

  return (
    <aside className="result-panel" aria-live="polite">
      <div className="result-header">
        <span>
          <Cpu size={16} /> {t.result}
        </span>
      </div>
      <p className="result-label">{t.labels[result.label]}</p>
      <div className="result-value">
        {formatNumber(resultValue, resultDecimals, locale)}
        <span>{unitFor(result.metric, unitSystem)}</span>
      </div>
      <div className="formula-box">
        <span>
          <Sigma size={15} /> {t.formula}
        </span>
        <code>{result.formula}</code>
      </div>
      <div className="detail-grid">
        {result.details.map((detail) => {
            const displayValue = toDisplayValue(detail.metric, detail.value, unitSystem);
            const decimals = compactDecimalsFor(detail.metric, unitSystem, displayValue);

            return (
              <div key={detail.label}>
                <span>{t.labels[detail.label]}</span>
                <strong>
                  {formatNumber(displayValue, decimals, locale)} {unitFor(detail.metric, unitSystem)}
                </strong>
              </div>
            );
          })}
      </div>
    </aside>
  );
}
